import React, { useEffect, useState } from 'react';
import { COUNTDOWN_SECONDS } from '../lib/constants';
type Props = {
  label?: string;
  tone?: 'light' | 'dark';
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  label = 'Esta oferta expira en',
  tone = 'light'
}: Props) {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => prev <= 1 ? COUNTDOWN_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const isDark = tone === 'dark';
  return <div className={`mx-auto flex w-full max-w-sm flex-col items-center gap-2 rounded-2xl border px-4 py-3 ${isDark ? 'border-white/15 bg-white/5 text-white' : 'border-navy-100 bg-white text-navy-800'}`} role="timer" aria-live="off" data-id="element-19" data-mp="371zy5pdjq5fv">
      <p className={`text-[10.5px] font-bold uppercase tracking-[0.16em] ${isDark ? 'text-gold-300' : 'text-gold-600'}`} data-id="element-20" data-mp="y0endtowvxxs">
        {label}
      </p>
      <div className="flex items-center gap-2" data-id="element-21" data-mp="17qq28ba4vrjg">
        {[{
        value: pad(minutes),
        unit: 'min'
      }, {
        value: pad(seconds),
        unit: 'seg'
      }].map((item, index) => <React.Fragment key={item.unit} data-id="element-22" data-mp="f22em91wwq2q" data-mpi={index}>
            {index === 1 ? <span className={`pb-3 text-2xl font-bold ${isDark ? 'text-white/40' : 'text-navy-300'}`} data-id="element-23" data-mp="f4ew6l3rcyf9">
                :
              </span> : null}
            <div className="flex flex-col items-center" data-id="element-24" data-mp="o3s5ndrvtmzz">
              <span className={`min-w-[3.25rem] rounded-xl px-2 py-1.5 text-center font-display text-2xl font-bold tabular-nums sm:text-3xl ${isDark ? 'bg-white text-navy-900' : 'bg-navy-800 text-white'}`} data-id="element-25" data-mp="k1ndykkzv0fz">
                {item.value}
              </span>
              <span className={`mt-1 text-[9.5px] font-semibold uppercase tracking-[0.14em] ${isDark ? 'text-white/60' : 'text-navy-400'}`} data-id="element-26" data-mp="s6g0t2xsqpcw">
                {item.unit}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}